import { getThemeData, Theme } from './widgets/ThemeProvider';
var themePackage = { Theme: Theme, getThemeData: getThemeData };
export { Theme, getThemeData };
// eslint-disable-next-line import/no-default-export
export default themePackage;
